module.exports = __webpack_public_path__ + "static/media/awards_16.e2068fcc.jpg";